import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { IoIosArrowDropleftCircle } from 'react-icons/io';
import ShoppingCartBadgeComponent from '../Extras';
import { addFooterItemAction } from '../../redux/actions'

const headerStyle = {
	backgroundColor: 'white',
	fontSize: '20px',
	color: 'white',
	borderBottom: '2px solid #E7E7E7',
	textAlign: 'center',
	paddingTop: '10px',
	top: '0',
	height: '60px',
	width: '100%',
	zIndex: 3
};

const headerLetters = {
	fontSize: 23,
	color: 'black',
	fontWeight: 'bold',
};

const headerLetters2 = {
	fontSize: 15,
	color: 'black',
	fontWeight: 'bold',
	paddingTop: '10px'
};

class Header extends React.Component {

	displayName = () => {
		if(this.props.shopName.length > 15){
			return(
				<Link key={'2'} to={{ pathname: `/${this.props.userName}/products`}} onClick={() => this.props.addFooterItem({categories: 1, aboutUs: 0, shoppingCart: 0})}>		
					<p style={headerLetters2}> {this.props.shopName} </p>
				</Link>
				)
		} else {
			return(
				<Link key={'2'} to={{ pathname: `/${this.props.userName}/products`}} onClick={() => this.props.addFooterItem({categories: 1, aboutUs: 0, shoppingCart: 0})}>		
					<p style={headerLetters}> {this.props.shopName} </p>
				</Link>
			)
		}
	}

	render() {
		return (
			<Fragment>
				<div className="col-md-3 offset-md-4" style={headerStyle}>
					<div className="row">

						<div className="col-2">
							{this.props.arrowLeft ? 
								<div className="row ml-2">
									<Link  style={{ color: 'lightgray' }} to={{ pathname: `/${this.props.location.pathname.split('/')[1]}/products/${this.props.category}` }}>
										<IoIosArrowDropleftCircle size={25} style={{ width: '100%', color: this.props.shopColor}} />
									</Link>
								</div> : ''}
						</div>

						<div className="col-8">
							{this.displayName()}		
						</div>

						{this.props.toggleWhatsAppMethod === true || this.props.toggleDelivery === true || this.props.toggleWithdrawal === true ? 
							<div className="col-2">
								<Link key={'4'} to={{ pathname: `/${this.props.userName}/shoppingCart` }} onClick={() => this.props.addFooterItem({categories: 0, aboutUs: 0, shoppingCart: 0})}>
									<ShoppingCartBadgeComponent/>
								</Link>
							</div> : ''}

					</div>
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	shopName: state.shopName,
	userName: state.userName,
	shopColor: state.shopColor,
	category: state.category,	
	location: state.location,
	toggleWithdrawal: state.toggleWithdrawal,
	toggleDelivery: state.toggleDelivery,
	toggleWhatsAppMethod: state.toggleWhatsAppMethod
});

const mapDispatchToProps = (dispatch) => ({
	addFooterItem(item) {
		dispatch(addFooterItemAction(item));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
